//import React, { useEffect } from 'react';
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import StocksType from './StocksType';

///const filter = createFilterOptions<StocksType>();

export default function Home() {
  const [value, setValue] = React.useState<StocksType | null>(null);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState<StocksType[]>([]);

  const [data, setData] = React.useState({
    ticker: "",
    company_name: "",
    open: "",
    change_percent: "",
    change: "",
    public_float: "",
    outstanding_shares: "",
    latest_volume: 0
  });

  const debounce = (func: Function, wait: number) => {
    let timeout: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const searchCache = React.useRef<Record<string, StocksType[]>>({});

  const searchStocks = React.useCallback(
    debounce(async (searchTerm: string) => {
      if (searchTerm.length < 2) {
        setOptions([]);
        return;
      }

      if (searchCache.current[searchTerm]) {
        setOptions(searchCache.current[searchTerm]);
        return;
      }

      try {
        const response = await fetch(`/stocks/search?q=${encodeURIComponent(searchTerm)}`);
        const data = await response.json();
        searchCache.current[searchTerm] = data;
        setOptions(data);
      } catch (error) {
        console.error('Error fetching stocks:', error);
        setOptions([]);
      }
    }, 300),
    []
  );

  const handleFormSubmit = (selectedValue: StocksType | null) => {
    if (selectedValue) {
      window.location.href = `/search?stock=${encodeURIComponent(selectedValue.name)}`;
    }
  };

  return (
    <>
      <style>
        {`.home-container {
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
          }
          .search-section {
            text-align: center;
            margin-bottom: 2rem;
          }
          .search-section h1 {
            white-space: nowrap;
            font-size: clamp(1.5rem, 4vw, 2rem);
          }
          .search-form {
            display: flex;
            gap: 0.5rem;
            align-items: center;
          }
          .search-button {
            background-color: #007bff;
            color: white;
            padding: 10px;
          }
          .search-button:hover {
            background-color: #0056b3;
          }`}
      </style>
      <div className="home-container">
        <div className="search-section">
          <h1>Find a stock to analyze</h1>
          <form className="search-form" action="/search" method="get" onSubmit={(e) => {
            e.preventDefault();
            handleFormSubmit(value);
          }}>
            <Autocomplete<StocksType, false, false, true>
              value={value}
              onChange={(event: React.SyntheticEvent, newValue: StocksType | null) => {
                setValue(newValue);
                if (newValue) {
                  handleFormSubmit(newValue);
                }
              }}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
                searchStocks(newInputValue);
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="stock-search"
              options={options}
              getOptionLabel={(option: StocksType) => option.name}
              renderOption={(props, option: StocksType) => {
                return (
                  <li {...props}>{option.name}</li>
                );
              }}
              fullWidth
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="stock"
                  label="Enter stock name or ticker"
                  variant="outlined"
                  sx={{ flexGrow: 1 }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                  autoComplete="off"
                />
              )}
            />
            <IconButton type="submit" className="search-button" aria-label="search">
              <SearchIcon />
            </IconButton>
          </form>
        </div>
      </div>
    </>
  );
}
